import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation, Pagination } from "swiper/modules";
class Carousel {
    constructor() {
        this.scheduleSwiper = null;
        //TOPページ
        this.scheduleSliders();
        this.informationSliders();
        this.featureCarousel();
        this.blogSliders();
        this.eventSliders();
        //COURSEページ
        this.courseSliders();
        this.courseBlogSliders();
        this.courseWorksSliders();
        //TOURページ
        this.voiceSliders();
        //FORTEページ
        this.forteSliders();
        //在校生・在校生の保護者の方へお知らせ
        this.pageSliders();
    }
    initScheduleSliders() {
        if (window.innerWidth <= 768) {
            if (!this.scheduleSwiper) {
                this.scheduleSwiper = new Swiper("#scheduleCarousel", {
                    modules: [Navigation],
                    speed: 800,
                    centeredSlides: true,
                    slidesPerView: "auto",
                    loop: true,
                    updateOnWindowResize: true,
                    autoHeight: false,
                    navigation: {
                        nextEl: "#schedule-arrows-sp .slide-prev",
                        prevEl: "#schedule-arrows-sp .slide-next",
                    },
                    on: {
                    //resize: function (swiper: Swiper) {},
                    },
                });
            }
        }
        else {
            if (this.scheduleSwiper) {
                this.scheduleSwiper.destroy();
                this.scheduleSwiper = null;
            }
        }
    }
    scheduleSliders() {
        this.initScheduleSliders();
        window.addEventListener("resize", () => {
            this.initScheduleSliders();
        });
    }
    informationSliders() {
        new Swiper("#infoCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            pagination: {
                el: "#info-indicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#info-arrows-sp .slide-prev",
                prevEl: "#info-arrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    loop: false,
                    centeredSlides: false,
                    navigation: {
                        nextEl: "#info-arrows .slide-prev",
                        prevEl: "#info-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    featureCarousel() {
        window.addEventListener("DOMContentLoaded", () => {
            new Swiper("#featureCarousel", {
                modules: [Autoplay, FreeMode],
                slidesPerView: "auto",
                speed: 7000,
                loop: true,
                loopAdditionalSlides: 2,
                spaceBetween: 0,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                freeMode: {
                    enabled: true,
                    momentum: false,
                },
                grabCursor: true,
                on: {
                    touchEnd: (swiper) => {
                        swiper.slideTo(swiper.activeIndex + 1);
                    },
                },
            });
        });
    }
    blogSliders() {
        new Swiper("#blogCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            pagination: {
                el: "#blog-indicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#blog-arrows-sp .slide-prev",
                prevEl: "#blog-arrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    navigation: {
                        nextEl: "#blog-arrows .slide-prev",
                        prevEl: "#blog-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    eventSliders() {
        new Swiper("#eventTypeCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            //centeredSlides: true,
            slidesPerView: "auto",
            //loop: true,
            //autoHeight: false,
            updateOnWindowResize: true,
            pagination: {
                el: "#eventType-indicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#eventType-arrows-sp .slide-prev",
                prevEl: "#eventType-arrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    navigation: {
                        nextEl: "#eventType-arrows .slide-prev",
                        prevEl: "#eventType-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    courseSliders() {
        new Swiper("#courseCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            //loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            pagination: {
                el: "#course-indicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#course-arrows-sp .slide-prev",
                prevEl: "#course-arrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    navigation: {
                        nextEl: "#course-arrows .slide-prev",
                        prevEl: "#course-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    courseBlogSliders() {
        new Swiper("#courseBlogCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            navigation: {
                nextEl: "#courseBlog-arrows-sp .slide-prev",
                prevEl: "#courseBlog-arrows-sp .slide-next",
            },
            pagination: {
                el: "#courseBlog-indicator",
                type: "progressbar",
            },
            breakpoints: {
                768: {
                    centeredSlides: false,
                    navigation: {
                        nextEl: "#courseBlog-arrows .slide-prev",
                        prevEl: "#courseBlog-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    courseWorksSliders() {
        new Swiper("#courseWorksCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            pagination: {
                el: "#courseWorks-indicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#courseWorks-arrows-sp .slide-prev",
                prevEl: "#courseWorks-arrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    navigation: {
                        nextEl: "#courseWorks-arrows .slide-prev",
                        prevEl: "#courseWorks-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    voiceSliders() {
        new Swiper("#exVoiceCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            //loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            navigation: {
                nextEl: "#exVoiceCarousel-arrows-sp .slide-prev",
                prevEl: "#exVoiceCarousel-arrows-sp .slide-next",
            },
            pagination: {
                el: "#exVoiceCarousel-indicator",
                type: "progressbar",
            },
            breakpoints: {
                768: {
                    centeredSlides: false,
                    navigation: {
                        nextEl: "#exVoiceCarousel-arrows .slide-prev",
                        prevEl: "#exVoiceCarousel-arrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
    forteSliders() {
        const sliders = document.querySelectorAll(".pForte__item-slider .swiper");
        sliders.forEach((slider) => {
            var _a;
            const pagination = (_a = slider
                .closest(".pForte__item-slider")) === null || _a === void 0 ? void 0 : _a.querySelector(".pForte__item-indicator");
            new Swiper(slider, {
                modules: [Autoplay, Pagination],
                speed: 800,
                centeredSlides: true,
                slidesPerView: "auto",
                loop: true,
                updateOnWindowResize: true,
                autoHeight: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    bulletClass: "pForte__item-bullet",
                    bulletActiveClass: "is-active",
                },
            });
        });
    }
    pageSliders() {
        new Swiper("#cCarousel", {
            modules: [Navigation, Pagination],
            speed: 800,
            centeredSlides: true,
            slidesPerView: "auto",
            loop: true,
            updateOnWindowResize: true,
            autoHeight: false,
            pagination: {
                el: "#cIndicator",
                type: "progressbar",
            },
            navigation: {
                nextEl: "#cArrows-sp .slide-prev",
                prevEl: "#cArrows-sp .slide-next",
            },
            breakpoints: {
                768: {
                    loop: false,
                    centeredSlides: false,
                    navigation: {
                        nextEl: "#cArrows .slide-prev",
                        prevEl: "#cArrows .slide-next",
                    },
                },
            },
            on: {
                resize: function (swiper) {
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.update();
                },
            },
        });
    }
}
new Carousel();
/*
document.addEventListener("DOMContentLoaded", () => {
  const infiniteSlider = new Swiper(".infinite-slider", {
    modules: [Autoplay], // 必要なモジュールを明示的に指定
    loop: true,
    slidesPerView: "auto",
    speed: 8000,
    centeredSlides: true,
    allowTouchMove: false,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },
  });
}); */
